import { formatMessage } from "lib/globalize-util";
import React from "react";

const listOfSpecifications = [
    "XLS, XLSX, or CSV only",
    "Remove any additional columns that are not part of the import.",
    "All column headers must be exact. Tip: Use the Export feature to start from a template.",
    "Maximum file size: 2MB",
];

export const useFileSpecificationsAndTipsForUpload = () => {
    return {
        title: formatMessage("File specifications & upload tips:"),
        items: listOfSpecifications.map((spec, index) => <li key={`${spec}-${index}`}>{formatMessage(spec)}</li>),
    };
};
